import React, { ReactElement } from 'react';
import useStyles from './CardWrapper.styles';

interface Props {
  children: ReactElement | ReactElement[]
}

const CardWrapper: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { children } = props;
  return <div className={classes.root}>{children}</div>;
};

export default CardWrapper;
